<template>
  <div class="item"
    :class="{
      pause: item.disabled || !(isPossible.result || isPay),
      request: count > 0 && !item.disabled
    }"
    :style="count > 0 && !item.disabled && { ...skinStyle('amenityActivate', 'border-color'), ...skinStyle('amenityActivate', 'color') }">
    <div class="inner">
      <div class="box">
        <div class="icon"><img :src="src" alt="" /></div>
        <div class="name toCapitalize">
          {{getItemName}}
          <!-- <div v-if="limitMessage" class="limitMessage">
            <p>{{ limitMessage.message }}</p>
            <p v-if="limitMessage.price">{{locale.message_amenity_limit_pay}}</p>
          </div> -->
          <p v-if="isPay" class="price">{{priceFormat(item.price)}}</p>
        </div>
      </div>
      <div v-if="!item.disabled && (isPossible.result || isPay)" class="quantity">
        <button type="button" class="minus" @click="onDec" :disabled="count <= 0 || !roomKey"><span class="blind">-</span></button>
        <button type="button" class="plus" @click="onInc" :disabled="(isPay ? count >= item.max : count >= itemMax) || !roomKey"><span class="blind">+</span></button>
        <input type="text" class="input" v-model="count" disabled />
      </div>
      <div v-else>
        <div class="pauseMessage colorGrey">
          <span>{{locale.amenity_pause}}</span>
          <div class="message" v-html="limitMessage"></div>
          <!-- <p v-if="!isPossible.result && isPossible.message">{{isPossible.message}}</p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'amenityItem',
  props: [
    'lang',
    'locale',
    'localeamenity',
    'item',
    'roomKey'
  ],
  computed: {
    setting () {
      return this.$store.getters['amenity/getAmenitySetting']
    },
    limitMessage () {
      const lang = this.$route.params.ln
      const limitMessage = this.setting.orderLimitMessage
      const message = limitMessage && limitMessage[lang]
      return message && message.length
        ? message.split('\n').join('<br>')
        : null
    },
    pointColors () {
      return this.$store.getters['common/getPointColors']
    },
    siteCommon () {
      return this.$store.getters['common/getSetting']
    },
    code () {
      return this.item.raCode.toLowerCase()
    },
    src () {
      const thumb = this.item.thumb
      const image = `${this.code}.png`
      return thumb ||  require(`@/assets/img/amenity/${image}`)
    },
    getItemName () {
      const itemName = `amenity_${this.code}`
      const lang = this.$route.params.ln
      return this.item.label
        ? this.item.label[lang]
        : this.localeamenity[itemName]
    },
    requestData () {
      return {
        item: this.item.raCode,
        count: this.count,
        ...this.isPay && {
          price: this.item.price
        },
        ...this.item.label && {
          label: this.item.label
        },
        ...this.item.pid && {
          pid: this.item.pid
        }
      }
    },
    itemMax () {
      const max = this.item.max
      function getMax (max, count) {
        return max - count <= 0 ? 0 : max - count
      }
      const result = this.item.orderLimitActive
        ? this.item.orderLimit === 'day'
          ? getMax(max, this.item.orderedToday)
          : getMax(max, this.item.orderedOta)
        : max
      return result
    },
    isPossible () {
      let possible = this.itemMax > 0 && this.count <= this.itemMax
      let message = null
      if (this.item.orderLimitActive) {
        const orderLimit = this.item.orderLimit
        possible = orderLimit === 'day'
          ? this.item.orderedCountToday < this.item.orderMax // 1일 요청가능 횟수
          : this.item.orderedCountOta < this.item.orderMax // 투숙기간중 요청가능 횟수
        message = orderLimit === 'day'
          ? this.locale.amenity_order_max_day.replace('{var}', this.item.orderMax)
          : this.locale.amenity_order_max_ota.replace('{var}', this.item.orderMax)
      }
      if (this.itemMax === 0 || this.item.disabled) {
        possible = false
        message = this.locale.ask_front
      }
      return {
        result: possible,
        message: message
      }
    },
    isPay () {
      const isPossible = this.isPossible.result
      const hasPrice = this.item.pay && this.item.price && this.item.price > 0
      return !isPossible && hasPrice
    },
    /*
    limitMessage () {
      const hasLimit = this.item.orderLimitActive
      const orderLimit = this.item.orderLimit
      const orderMax = this.item.orderMax
      const price = this.item.pay && this.item.price
      const message = orderLimit === 'day' ? this.locale.message_amenity_limit_day : this.locale.message_amenity_limit_ota
      return hasLimit
        ? {
          message: message && message.replace('{var}', orderMax),
          price: price && price.length > 0
        }
        : null
    }
    */
  },
  watch: {
    count (c) {
      const commit = c > 0 ? 'amenity/addRequest' : 'amenity/delRequest'
      this.$store.commit(commit, this.requestData)
    }
  },
  mounted () {
    const request = this.$store.getters['amenity/getamenityRequest']
    const raCode = this.item.raCode
    const item = request && request.find(x => x.item === raCode)
    if (item && item.count > 0) {
      this.count = item.count
    }
  },
  data () {
    return {
      count: 0
    }
  },
  methods: {
    skinStyle (target, attr) {
      return this.pointColors(target, attr)
    },
    priceFormat (price) {
      const code = this.siteCommon.currency.toUpperCase()
      return regExp.priceFormat(price, code)
    },
    onDec () {
      if (this.count > 0) {
        this.count -= 1
      }
    },
    onInc () {
      const max = this.isPay ? this.item.max : this.itemMax
      if (this.count < max) {
        this.count += 1
      } else {
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  width: calc(50% - 16px);
  margin-bottom: 15px;
  margin-left: 8px;
  margin-right: 8px;
  text-align: center;
  font-size: 14px;
  border: 1px solid $color-lgrey2;
  border-radius: 8px;
  overflow: hidden;
  &.pause {
    background-color: rgba($color-lgrey2, 0.15);
    .box {
      opacity: 0.5;
    }
  }
  &.request {
    font-weight: 700;
    color: $color-primary;
    border-color: $color-primary;
  }
}
.inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: $color-white;
}
.box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  padding: 30px 0 20px;
}
.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin: 0 auto;
  opacity: 0.75;
}
.name {
  padding: 15px 0.3em 0;
}
.limitMessage {
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.3;
  opacity: 0.5;
}
.quantity {
  position: relative;
  text-align: center;
  border-top: 1px solid $color-lgrey2;
  input[disabled] {
    width: 100%;
    min-height: 0;
    padding: 0.3em 45px;
    font-size: 1.2em;
    font-weight: 700;
    text-align: center;
    border: none;
    color: inherit;
    opacity: 1;
    -webkit-text-fill-color: inherit;
    background: none;
  }
  button {
    position: absolute;
    top: 0;
    width: 45px;
    height: 100%;
    font-size: 1.2em;
    z-index: 1;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 14px;
      height: 2px;
      background-color: $color-lgrey;
      transform: translate(-50%, -50%);
    }
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 2px;
      height: 14px;
      background-color: $color-lgrey;
      transform: translate(-50%, -50%);
    }
    &[disabled] {
      cursor: not-allowed;
      background-color: rgba($color-lgrey2, 0.3);
    }
  }
  .minus {
    left: 0;
    border-right: 1px solid $color-lgrey2;
    &:after {
      display: none;
    }
  }
  .plus {
    right: 0;
    border-left: 1px solid $color-lgrey2;
  }
}
.pauseMessage {
  margin-top: auto;
  padding: 0.5em 0.8em;
  text-align: center;
  text-transform: none;
  border-top: 1px solid $color-lgrey2;
  .message {
    font-size: 0.85em;
    font-weight: normal;
    opacity: 0.75;
  }
}

// @media screen and (min-width: 640px) {
//   .item {
//     width: calc(33.33% - 16px);
//   }
// }
@media screen and (min-width: 1200px) {
  .item {
    width: calc(33.33% - 16px);
    font-size: 16px;
  }
  .icon {
    width: 40px;
    height: 40px;
  }
  .name {
    padding-top: 1em;
  }
}
@media screen and (min-width: 1600px) {
  .item {
    width: calc(25% - 16px);
  }
}
</style>
